import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";
import Box, { type BoxProps } from "../../Box";

type Props = BoxProps;

export const OnboardingBox = (props: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box
			paddingVertical={isMobile ? 0 : 24}
			paddingHorizontal={isMobile ? 0 : 24}
			gap={24}
			backgroundColor={isMobile ? undefined : theme.colors.surface}
			borderRadius={isMobile ? 0 : theme.roundness * 3}
			borderWidth={isMobile ? 0 : 1}
			borderColor={theme.colors.surfaceVariant}
			{...props}
		/>
	);
};
